import { Users, Clock, CheckCircle, XCircle } from "lucide-react";
import type { StatCardConfig } from "../../common/StatsCards";

export const STAT_CARDS: StatCardConfig[] = [
  {
    key: "total",
    label: "Total Requests",
    icon: Users,
    iconBg: "var(--color-primary-100)",
    iconColor: "var(--color-primary-600)",
  },
  {
    key: "pending",
    label: "Pending Review",
    icon: Clock,
    iconBg: "var(--color-warning-light)",
    iconColor: "var(--color-warning-dark)",
  },
  {
    key: "approved",
    label: "Approved",
    icon: CheckCircle,
    iconBg: "var(--color-success-light)",
    iconColor: "var(--color-success)",
  },
  {
    key: "rejected",
    label: "Rejected",
    icon: XCircle,
    iconBg: "var(--color-error-light)",
    iconColor: "var(--color-error)",
  },
];

export const DEFAULT_VISIBLE_KEYS: string[] = [
  "employee",
  "dateType",
  "requestedTime",
  "reason",
  "status",
  "actions",
];
